// src/components/FilterControls.js
import React from 'react';
import { SlidersHorizontal, ArrowDown, ArrowUp } from 'lucide-react';
import './FilterControls.css';

// Botões Padrão (Serão usados se a página não enviar filtros customizados)
const DEFAULT_TAG_OPTIONS = [
    { key: 'HAS', label: 'Hipertenso' },
    { key: 'DM', label: 'Diabético' },
    { key: 'Gestante', label: 'Gestante' },
    { key: 'Idoso', label: 'Idoso (+60)' },
    { key: 'Acamado,Domiciliado', label: 'Acamado/Domiciliado' },
];

const ALL_SORT_OPTIONS = [
    { key: 'endereco', label: 'Endereço' },
    { key: 'nome', label: 'Nome' },
    { key: 'dt_nascimento', label: 'Idade' },
    { key: 'ultima_visita', label: 'Última Visita' },
];

export default function FilterControls({ 
    sortConfig, setSortConfig, 
    activeAlerts, setActiveAlerts,
    microAreas, selectedMicroArea, setSelectedMicroArea,
    hiddenFilters = [], 
    hiddenSorts = null,
    customFilters = null // Prop que permite injetar faixas etárias e filtros específicos
}) {
    
    // Define quais filtros renderizar (Customizados da página ou Padrão)
    const filtersToRender = customFilters ? customFilters : DEFAULT_TAG_OPTIONS;

    // Padrão de ocultação para a ordenação
    const sortsToHide = hiddenSorts !== null ? hiddenSorts : ['ultima_visita'];

    // Lógica de 3 Estados (Ascendente -> Descendente -> Desligado)
    const handleSortChange = (key) => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'ascending') {
                setSortConfig({ key, direction: 'descending' });
            } else {
                setSortConfig({ key: 'default', direction: 'ascending' });
            }
        } else {
            setSortConfig({ key, direction: 'ascending' });
        }
    };

    const handleAlertToggle = (alertKey) => {
        setActiveAlerts(prev => 
            prev.includes(alertKey) ? prev.filter(k => k !== alertKey) : [...prev, alertKey]
        );
    };

    return (
        <div className="filter-controls-container">
            <div className="control-row">
                <div className="control-group">
                    <label className="control-label">Ordenar:</label>
                    <div className="sort-buttons">
                        {ALL_SORT_OPTIONS.map(opt => {
                            if (sortsToHide.includes(opt.key)) return null;

                            const isActive = sortConfig.key === opt.key;

                            return (
                                <button 
                                    key={opt.key}
                                    className={`sort-btn ${isActive ? 'active' : ''}`}
                                    onClick={() => handleSortChange(opt.key)}
                                    title={isActive ? "Clique para inverter ou remover" : "Clique para ordenar"}
                                >
                                    {opt.label}
                                    {isActive && (
                                        sortConfig.direction === 'ascending' ? <ArrowUp size={14} /> : <ArrowDown size={14} />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div className="control-group" style={{ marginLeft: 'auto' }}>
                    <label className="control-label">Micro-área:</label>
                    <select 
                        className="filter-select"
                        value={selectedMicroArea}
                        onChange={(e) => setSelectedMicroArea(e.target.value)}
                    >
                        <option value="">Todas as Áreas</option>
                        {microAreas.map(area => (
                            <option key={area} value={area}>Área {area}</option>
                        ))}
                    </select>
                </div>
            </div>
            
            <hr className="divider" />

            <div className="control-row">
                <div className="control-group">
                    <label className="control-label"><SlidersHorizontal size={14}/> Filtros Inclusivos:</label>
                    <div className="alert-checkboxes">
                        {filtersToRender.map(opt => {
                            // Ignora botões que a página pediu para esconder
                            if (hiddenFilters.includes(opt.key)) return null;
                            
                            return (
                                <label key={opt.key} className={`checkbox-chip ${activeAlerts.includes(opt.key) ? 'active' : ''}`}>
                                    <input 
                                        type="checkbox"
                                        checked={activeAlerts.includes(opt.key)}
                                        onChange={() => handleAlertToggle(opt.key)}
                                        style={{display: 'none'}}
                                    />
                                    {opt.label}
                                </label>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}